// extracted by mini-css-extract-plugin
export default {"dropzone":"Dropzone_dropzone__xartW","dropzone--active":"Dropzone_dropzone--active__bY0B4"};